module.exports = __webpack_public_path__ + "static/media/slot-icon.b562b0b6.png";